<template>
  <b-overlay
      :show="showOverlay"
      rounded="sm"
  >
    <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <vuexy-logo />
<!--        <h2 class="brand-text text-primary ml-1">-->
<!--          Vuexy-->
<!--        </h2>-->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            class="mb-1 font-weight-bold"
            title-tag="h2"
          >
            به پنل ادمین ذهن آرایی خوش آمدید 👋
          </b-card-title>
          <b-card-text class="mb-2">
            لطفا به حساب کاربری خود وارد شوید.
          </b-card-text>


          <!-- form -->
          <validation-observer
            ref="loginForm"
            #default="{invalid}"
          >
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent="login"
            >
              <!-- email -->
              <b-form-group
                label="تلفن همراه"
                label-for="login-mobile"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Mobile"
                  vid="mobile"
                  rules="required|integer"
                >
                  <b-form-input
                    id="login-mobile"
                    :state="errors.length > 0 ? false:null"
                    v-model="mobile"
                    name="login-mobile"
                    placeholder="---------09"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
<!--                <div class="d-flex justify-content-between">-->
<!--                  <label for="login-password">رمز عبور</label>-->
<!--                  <b-link :to="{name:'auth-forgot-password'}">-->
<!--&lt;!&ndash;                    <small>Forgot Password?</small>&ndash;&gt;-->
<!--                  </b-link>-->
<!--                </div>-->
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="*****"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  مرا به خاطر بسپار
                </b-form-checkbox>
              </b-form-group>

              <!-- submit buttons -->
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                ورود
              </b-button>

            </b-form>
          </validation-observer>

<!--          <b-card-text class="text-center mt-2">-->
<!--            <span>New on our platform? </span>-->
<!--            <b-link :to="{name:'auth-register'}">-->
<!--              <span>&nbsp;Create an account</span>-->
<!--            </b-link>-->
<!--          </b-card-text>-->

<!--          &lt;!&ndash; divider &ndash;&gt;-->
<!--          <div class="divider my-2">-->
<!--            <div class="divider-text">-->
<!--              or-->
<!--            </div>-->
<!--          </div>-->

<!--          &lt;!&ndash; social buttons &ndash;&gt;-->
<!--          <div class="auth-footer-btn d-flex justify-content-center">-->
<!--            <b-button-->
<!--              variant="facebook"-->
<!--              href="javascript:void(0)"-->
<!--            >-->
<!--              <feather-icon icon="FacebookIcon" />-->
<!--            </b-button>-->
<!--            <b-button-->
<!--              variant="twitter"-->
<!--              href="javascript:void(0)"-->
<!--            >-->
<!--              <feather-icon icon="TwitterIcon" />-->
<!--            </b-button>-->
<!--            <b-button-->
<!--              variant="google"-->
<!--              href="javascript:void(0)"-->
<!--            >-->
<!--              <feather-icon icon="MailIcon" />-->
<!--            </b-button>-->
<!--            <b-button-->
<!--              variant="github"-->
<!--              href="javascript:void(0)"-->
<!--            >-->
<!--              <feather-icon icon="GithubIcon" />-->
<!--            </b-button>-->
<!--          </div>-->
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
  </b-overlay>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, VBTooltip,BOverlay
} from 'bootstrap-vue'
import useJwt from '@/auth/jwt/useJwt'
import { required, email , integer} from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'

import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    VuexyLogo,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      mobile:'',
      showOverlay:false,
      // userEmail: 'admin@demo.com',
      sideImg: require('@/assets/images/pages/login-v2.svg'),

      // validation rules
      required,
      integer
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then(success => {
        if (success) {
          this.showOverlay = true;
          useJwt.login({
            mobileOrEMail: this.mobile,
            password: this.password,
          }).then(response => {
            this.showOverlay = false;

            // Success
            if (response.data.isSuccess){
              const userData = response.data.data.data
              const userRole = userData.user.role;

              if(userRole === 'Subscriber'){
                return  this.$toast({
                  component: ToastificationContent,
                  position: 'bottom-left',
                  props: {
                    variant: 'danger',
                    text: "شما اجازه ورود به پنل ادمین ندارید.",
                  },
                })
              }

              userData['ability'] = [
                {
                  action: "manage",
                  subject: "all"
                }
              ]

              if(userRole === 'Blogger'){
                userData.ability[0].action = 'Blogger';
                userData.ability[0].subject = 'Blogger';
              }
              if(userRole === 'Accountent'){
                userData.ability[0].action = 'Accountent';
                userData.ability[0].subject = 'Accountent';
              }
              if(userRole === 'ProductManager'){
                userData.ability[0].action = 'ProductManager';
                userData.ability[0].subject = 'ProductManager';
              }
              if(userRole === 'PhoneSupport'){
                userData.ability[0].action = 'PhoneSupport';
                userData.ability[0].subject = 'PhoneSupport';
              }
              // if(userRole === 'SiteSupport'){
              //   userData.ability[0].action = 'PhoneSupport';
              //   userData.ability[0].subject = 'PhoneSupport';
              // }

              useJwt.setToken(userData.token)
              useJwt.setRefreshToken(userData.token)
              localStorage.setItem('userData', JSON.stringify(userData))
              this.$ability.update(userData.ability)

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              this.$toast({
                component: ToastificationContent,
                position: 'bottom-left',
                props: {
                  title: `خوش آمدید ${userData.user.name}`,
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: `شما به عنوان ${userData.user.role} وارد شدید.`,
                },
              })
              location.href = getHomeRouteForLoggedInUser(userRole)
            }else {
              return this.$toast({
                component: ToastificationContent,
                position: 'bottom-left',
                props: {
                  variant: 'danger',
                  text: response.data.errorMessage,
                },
              })
            }
          }).catch(error => {
            console.log(error)
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
